var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isEdit || (_vm.readonly && !_vm.job.lclMasterUuid),
                    expression: "isEdit||(readonly&&!job.lclMasterUuid)"
                  }
                ]
              },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    attrs: {
                      no: "changeSealHandler",
                      type: "primary",
                      disabled: _vm.selectedContainerUsage === null
                    },
                    on: { click: _vm.changeSealHandler }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("SeaExport.SealNoChangeAdfterInspection"))
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    attrs: { no: "AutoAllocation", type: "primary" },
                    on: { click: _vm.autoLoadHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AutoAllocation")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    attrs: {
                      no: "CleanOutTheLoadingRecord",
                      type: "primary",
                      disabled: _vm.selectedContainerUsage === null
                    },
                    on: { click: _vm.autoUnloadHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CleanOutTheLoadingRecord")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit && !_vm.job.lclMasterUuid,
                        expression: "isEdit&&!job.lclMasterUuid"
                      }
                    ],
                    attrs: {
                      no: "DeleteTheLoadingRecord",
                      type: "primary",
                      disabled: _vm.selectedContainerUsage === null
                    },
                    on: { click: _vm.deleteContainerHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteTheLoadingRecord")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit && _vm.isFCL,
                        expression: "isEdit&&isFCL"
                      }
                    ],
                    attrs: { no: "TemplateDownload", type: "primary" },
                    on: { click: _vm.downTemplateBtn_clickHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.TemplateDownload")))]
                ),
                _c(
                  "el-upload",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit && _vm.isFCL,
                        expression: "isEdit&&isFCL"
                      }
                    ],
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "5px"
                    },
                    attrs: {
                      no: "ExcelImport",
                      action: "string",
                      "http-request": _vm.importExcelEventHandler,
                      "show-file-list": false,
                      accept: ".xls, .xlsx",
                      "before-upload": _vm.beforeUploadUsage
                    }
                  },
                  [
                    _c("el-button", { attrs: { type: "primary" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))
                    ])
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.readonly &&
                          !_vm.job.lclMasterUuid &&
                          _vm.viewSource != "salesDetail",
                        expression:
                          "readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
                      }
                    ],
                    attrs: { no: "CallContainer", type: "primary" },
                    on: { click: _vm.callContainerEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("RailwayExport.CallContainer")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.readonly &&
                          !_vm.job.lclMasterUuid &&
                          _vm.viewSource != "salesDetail",
                        expression:
                          "readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
                      }
                    ],
                    attrs: { no: "BuyContainer", type: "primary" },
                    on: { click: _vm.buyContainerEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("RailwayExport.BuyContainer")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.readonly &&
                          !_vm.job.lclMasterUuid &&
                          _vm.viewSource != "salesDetail",
                        expression:
                          "readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
                      }
                    ],
                    attrs: { no: "RentContainer", type: "primary" },
                    on: { click: _vm.rentContainerEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("RailwayExport.RentContainer")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.readonly &&
                          !_vm.job.lclMasterUuid &&
                          _vm.viewSource != "salesDetail",
                        expression:
                          "readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
                      }
                    ],
                    attrs: { no: "ClearContainerLog", type: "primary" },
                    on: { click: _vm.clearContainerEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("RailwayExport.ClearContainerLog")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.readonly &&
                          !_vm.job.lclMasterUuid &&
                          _vm.viewSource != "salesDetail",
                        expression:
                          "readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
                      }
                    ],
                    attrs: { no: "ReturnBox", type: "primary" },
                    on: { click: _vm.returnBoxEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("RailwayExport.ReturnBox")))]
                )
              ],
              1
            ),
            _c("div", [
              _c(
                "span",
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("SeaExport.CargoQuantityDescription")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lblContainerDesc) +
                      " " +
                      _vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lbTotalQuantity) +
                      " " +
                      _vm._s(_vm.$t("SeaExport.TotalWeight")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lbTotalWeight) +
                      " " +
                      _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lbTotalCubage) +
                      " "
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.btnshowAWindow && !_vm.isEdit,
                          expression: "btnshowAWindow && !isEdit"
                        }
                      ],
                      attrs: { no: "ViewAssociatedBusiness", type: "primary" },
                      on: { click: _vm.showAWindowClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ViewAssociatedBusiness")))]
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.containerUsages || []
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("seal-number-change-dialog", {
        attrs: {
          visible: _vm.boxNoDialog.visible,
          "prop-form-data": _vm.selectedContainerUsage
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxNoDialog, "visible", $event)
          },
          sealCloseHandler: _vm.sealCloseHandler
        }
      }),
      _c("associated-business-dialog", {
        attrs: {
          visible: _vm.associatedBusinessDialog.visible,
          "a-data": _vm.associatedBusinessDialog.aData,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.associatedBusinessDialog, "visible", $event)
          },
          refresh: _vm.refresh
        }
      }),
      _c("call-container-dialog", {
        attrs: { visible: _vm.callContainerDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.callContainerDialog, "visible", $event)
          },
          successCallback: _vm.reload
        }
      }),
      _c("box-operation-dialog", {
        attrs: {
          visible: _vm.boxOperationDialog.visible,
          job: _vm.job,
          title: _vm.boxOperationDialog.title,
          "order-type": _vm.boxOperationDialog.orderType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxOperationDialog, "visible", $event)
          }
        }
      }),
      _c("return-box-dialog", {
        attrs: {
          visible: _vm.returnBoxDialog.visible,
          job: _vm.job,
          "select-list": _vm.returnBoxDialog.selectList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnBoxDialog, "visible", $event)
          },
          successCallback: _vm.reload
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }